<template>
    <div class="col-12">
        <load v-if="loading" message="Carregando dados" mode="table" />
        <div v-else class="card mb-2">
            <div
                class="d-flex justify-content-between align-items-center mx-0 row"
            >
                <div
                    class="col-sm-12 col-md-6 px-0 d-flex justify-content-start"
                >
                    <div v-for="(btn, b) in buttons" :key="b">
                        <a
                            :href="btn.url"
                            :class="btn.class"
                            :title="btn.label"
                            v-if="btn.url"
                        >
                            <i :class="btn.icon"></i>
                            {{ btn.name }}
                        </a>
                        <button
                            :class="btn.class"
                            @click="$emit(btn.emit, sortedRows)"
                            :title="btn.label"
                            v-if="btn.emit"
                        >
                            <i :class="btn.icon"></i>
                            {{ btn.name }}
                        </button>
                        <button
                            :class="btn.class"
                            data-toggle="modal"
                            :data-target="btn.dataid"
                            :title="btn.label"
                            v-else
                        >
                            <i :class="btn.icon"></i>
                            {{ btn.name }}
                        </button>
                    </div>

                    <button
                        class="btn btn-danger"
                        @click="clearFIltro"
                        title="Limpar Filtros"
                        v-if="statusFiltro"
                    >
                        <i class="mdi mdi-window-close"></i>
                        Limpar Filtros
                    </button>
                </div>
                <div
                    class="col-sm-12 px-0 d-flex justify-content-end"
                    :class="
                        buttons && buttons.length > 0 ? 'col-md-6' : 'col-md-12'
                    "
                >
                    <form-input-group
                        type="search"
                        v-model="searchColumnGlobal"
                        placeholder="Buscar"
                        :isButton="true"
                        class="px-0"
                        classInput="border-right-0"
                        btnClass="btn btn-default border-left-0"
                        iconBtn="mdi mdi-magnify mdi-22px"
                        @submit="
                            sort(i);
                            sortSelected = `sort-${column.id}`;
                        "
                    />
                </div>
            </div>

            <div
                v-if="columns.length > 1"
                class="dropdown dropdown-animated scale-left mt-0 mx-2"
                :class="showConfig && clickConfig ? 'show' : ''"
                @mouseleave="
                    showConfig = !showConfig;
                    clickConfig = false;
                "
                @click="
                    clickConfig = true;
                    showConfig = true;
                "
                style="position: absolute; right: 0; top: 58px"
            >
                <a
                    @click="showConfig = !showConfig"
                    class="dropdown-toggle rounded px-1"
                    aria-expanded="true"
                >
                    <i class="mdi mdi-cog"></i>
                </a>

                <ul
                    class="dropdown-menu rounded dropdown-md p-v-0"
                    :class="showConfig && clickConfig ? 'show' : ''"
                >
                    <li>
                        <a class="d-flex justify-content-between border-bottom">
                            <span>Colunas</span>
                            <i class="mdi mdi-checkbox-marked-outline"> </i>
                        </a>
                    </li>
                    <li v-for="(col, i) in columns" :key="i">
                        <a class="d-flex justify-content-between">
                            <form-toggle
                                grid="2"
                                class="px-0"
                                @click="checkColum(i)"
                                v-model="columns[i].checked"
                            />
                            <span>{{ col.label }}</span>
                        </a>
                    </li>
                </ul>
            </div>
            <table
                class="table b-table mb-3 table-striped table-hover table-sm border b-table-stacked-md"
            >
                <Header
                    :columns="columns"
                    @sort="sortRows"
                    @search="searchRows"
                    @clear="clearFIltro"
                    @click-search-line="clearSearch('global')"
                />
                <tbody>
                    <tr v-for="(item, i) in sortedRows" :key="i">
                        <td
                            v-for="(colum, c) in columns"
                            :key="c"
                            :style="`${
                                colum.checked == 1 ? '' : 'display:none'
                            }`"
                        >
                            <!-- <span
                                v-if="colum.template"
                                v-html="formatTemplate(colum.mask, item)"
                            >
                            </span> -->
                            <span
                                :class="`d-flex justify-content-${
                                    colum.align ? colum.align : 'center'
                                }`"
                                v-if="colum.checked == 1"
                            >
                                <span
                                    v-if="colum.toggle_switch"
                                    class="toggle-switch"
                                    :class="item.status ? 'active' : ''"
                                    @click="
                                        item.status = !item.status;
                                        $emit(
                                            'switch',
                                            item.id,
                                            item.status ? 1 : 0
                                        );
                                    "
                                >
                                    <span class="toggle-knob"></span>
                                </span>
                                <span
                                    v-if="
                                        !colum.toggle_switch &&
                                        colum.type == 'image'
                                    "
                                    ><img
                                        :src="item[colum.name]"
                                        :class="colum.class"
                                /></span>
                                <span
                                    v-if="
                                        !colum.toggle_switch &&
                                        colum.type != 'data' &&
                                        colum.type != 'image' &&
                                        colum.type != 'currencyReal'
                                    "
                                    v-html="item[colum.name]"
                                ></span>
                                <span v-if="colum.type == 'data'"
                                    >{{ formatData(item[colum.name]) }}
                                </span>
                                <span v-if="colum.type == 'currencyReal'"
                                    >{{ MaskCurrencyReal(item[colum.name]) }}
                                </span>
                                <ul v-if="colum.sub">
                                    <li
                                        v-for="(sub, s) in colum.sub"
                                        :key="s"
                                        :class="sub.class"
                                    >
                                        <b>{{ item[sub.name] }}</b>
                                        {{ sub.label }}
                                    </li>
                                </ul>
                            </span>
                        </td>
                        <td
                            v-if="
                                showactionlimit == undefined ||
                                item.id > showactionlimit
                            "
                            style="text-align: right"
                        >
                            <div class="btn-group" role="group">
                                <span v-for="(action, a) in actions" :key="a">
                                    <button
                                        v-if="
                                            action.is_edit == undefined ||
                                            (action.is_edit && item['is_edit'])
                                        "
                                        type="button"
                                        class="mx-1"
                                        :class="action.class"
                                        :title="action.label"
                                        @click="
                                            $emit(action.emit, item.id, i, item)
                                        "
                                    >
                                        <i :class="action.icon"></i>
                                    </button>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr class="text-center" v-if="sortedRows.length <= 0">
                        <td :colspan="columns.length">Nada Encontrado.</td>
                    </tr>
                </tbody>
            </table>
            <Paginacao
                ref="pagination"
                :total="countDados"
                :current="current"
                @update="updateValuesPagination"
                @load="loadPage"
            />
        </div>
    </div>
</template>
<script>
import Header from "./Header";
import Paginacao from "./includes/Paginacao";

export default {
    components: { Header, Paginacao },
    name: "TableApp",
    props: {
        data: {
            type: Array,
            default: [],
            required: true,
        },
        columns: {
            type: Array,
            default: [],
            required: true,
        },
        actions: {
            type: Array,
            default: [],
            required: true,
        },
        buttons: {
            type: Array,
        },
        showactionlimit: { type: Number },
        current: { type: Number },
        urlsearch: { type: String },
        loading: { type: Boolean },
    },
    data() {
        return {
            showConfig: false,
            clickConfig: false,
            currentSortDir: "desc",
            currentSort: "",
            currentLengthResult: 0,
            pageSize: 10,
            searchValue: "",
            searchColumnIndex: "",
            searchColumnGlobal: "",
            searchColumn: 0,
            searchType: "",
            anexoSelected: "",
            dataelected: "",
            tarefaPerPage: 0,
            currentPage: 1,
            startRow: 0,
            statusFiltro: false,
            countDados: 0,
            dataTemp: [],
            templateCout: 0,
            columnsSelected: [],
        };
    },
    mounted() {
        this.$emit("mounted");
    },
    methods: {
        formatData(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        MaskCurrencyReal(valor) {
            let valorFormatado = valor.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            });
            return valorFormatado;
        },
        checkColum(i) {
            //console.log(this.columns[i]);
            if (this.columns[i].checked == 1) {
                this.columns[i].checked = 0;
            } else {
                this.columns[i].checked = 1;
            }
            //console.log(this.columns[i]);
            //console.log(this.columns[i].checked);
        },
        formatTemplate(mask, item) {
            var temp = Object.entries(item);
            if (temp) {
                temp.filter((e, index) => {
                    if (mask.includes(`#${e[0]}#`)) {
                        mask = mask.replace(`#${e[0]}#`, e[1]);
                    }
                });
            }
            return mask;
        },
        getSubIndece(explode, item) {
            return item[explode[0]][explode[1]];
        },
        loadPage(current, pagesize) {
            this.$emit("load", current, pagesize);
        },
        sortRows(value) {
            var column = this.columns[value];

            if (column.name === this.currentSort) {
                this.currentSortDir =
                    this.currentSortDir === "asc" ? "desc" : "asc";
            }

            this.currentSort = column.name;
        },
        searchRows(index, value, columnIndex, type) {
            this.clearSearch("local");
            //   this.$emit("clear");

            //   axios.get(`${this.urlsearch}${index}|${value}`)
            //   .then(response=>{
            //       this.data = response.data;
            //     });

            this.searchValue = value;
            this.searchColumn = index;
            this.searchColumnIndex = columnIndex;

            this.searchType = type;
            this.$refs.pagination.currentPage = 1;

            this.columns[this.searchColumnIndex].searchModel = value;

            this.$emit("filtro", [
                this.searchValue,
                this.searchColumn,
                this.searchColumnIndex,
            ]);
        },
        searchRowsArray(index, value, columnIndex) {
            this.clearSearch("local");

            //   axios.get(`${this.urlsearch}${index}|${value}`)
            //   .then(response=>{
            //       this.data = response.data;
            //     });

            this.searchValue = value;
            this.searchColumn = index;
            this.searchColumnIndex = columnIndex;

            this.$refs.pagination.currentPage = 1;

            this.columns[this.searchColumnIndex].searchModel = value;

            this.$emit("filtro", [
                this.searchValue,
                this.searchColumn,
                this.searchColumnIndex,
            ]);
        },
        clearFIltro() {
            this.clearSearch("local");
            this.clearSearch("global");
            this.$emit("clearfiltro");
            this.statusFiltro = false;
        },
        clearSearch(tipo) {
            if (tipo == "local") {
                if (this.columns[this.searchColumnIndex] != undefined) {
                    if (
                        this.columns[this.searchColumnIndex].hasOwnProperty(
                            "searchModel"
                        )
                    ) {
                        this.columns[this.searchColumnIndex].searchModel = "";

                        this.searchValue = "";
                        this.searchColumn = "";
                        this.searchColumnIndex = "";
                    }
                }
            } else {
                this.searchColumnGlobal = null;
            }
            //   this.data = this.dataTemp;
        },
        buscarArray(value) {
            this.statusFiltro = true;
            this.$refs.pagination.currentPage = 1;
            this.clearSearch("local");
            var i = 0;

            while (i < this.columns.length) {
                if (
                    value[this.columns[i].name] != null &&
                    this.columns[i] != undefined
                ) {
                    var colunaValue = value[this.columns[i].name]
                        .toString()
                        .toLowerCase();

                    if (
                        colunaValue.includes(
                            this.searchColumnGlobal.toLowerCase()
                        )
                    ) {
                        return true;
                    }
                }
                i++;
            }
            return;
        },
        updateValuesPagination(page, size) {
            this.currentPage = parseInt(page);
            this.pageSize = parseInt(size);
        },
        filterDadosPorPagina(index, count, total) {
            this.countDados = count;

            if (this.pageSize > this.data.length) {
                let start = 0;
                let end = this.data.length;

                if (index >= start && index < end) return true;
            } else {
                let start = (this.currentPage - 1) * this.pageSize;
                let end = this.currentPage * this.pageSize;

                if (index >= start && index < end) return true;
            }
        },
    },
    computed: {
        sortedRows() {
            var count = 0;
            if (this.templateCout <= 1) {
                this.data.filter((el, index) => {
                    this.columns.filter((c) => {
                        if (c.template) {
                            this.data[index][c.name] = this.formatTemplate(
                                c.mask,
                                el
                            );
                        } else if (c.name.includes(".")) {
                            var explode = c.name.split(".");
                            this.data[index][c.name] = this.getSubIndece(
                                explode,
                                el
                            );
                        }
                    });
                });
                this.templateCout++;
            }
            if (this.searchColumnGlobal) {
                return this.data
                    .filter((item) => {
                        return this.buscarArray(item);
                    })
                    .filter((row, index) => {
                        count++;
                        return this.filterDadosPorPagina(
                            index,
                            count,
                            row.total
                        );
                    });
            } else {
                return this.data
                    .sort((a, b) => {
                        var label = this.currentSort;
                        let modifier = 1;
                        if (this.currentSortDir === "asc") modifier = -1;
                        if (a[this.currentSort] < b[this.currentSort])
                            return -1 * modifier;
                        if (a[this.currentSort] > b[this.currentSort])
                            return 1 * modifier;
                        return 0;
                    })
                    .filter((item) => {
                        const objectArray = Object.entries(item);
                        if (this.searchValue) {
                            if (Array.isArray(this.searchValue)) {
                                var value =
                                    item[this.searchColumn].toUpperCase();
                                var array = this.searchValue;
                                return array.includes(value);
                            } else {
                                this.statusFiltro = true;

                                if (item[this.searchColumn]) {
                                    if (this.searchType == "select") {
                                        return (
                                            item[this.searchColumn] ==
                                            this.searchValue
                                        );
                                    }
                                    var search = "";
                                    if (typeof this.searchValue == "number") {
                                        search = this.searchValue;
                                    } else {
                                        search = this.searchValue.toLowerCase();
                                    }
                                    if (
                                        typeof item[this.searchColumn] ===
                                        "string"
                                    ) {
                                        item[this.searchColumn] =
                                            item[
                                                this.searchColumn
                                            ].toLowerCase();
                                    }
                                    if (
                                        typeof item[this.searchColumn] ===
                                        "number"
                                    ) {
                                        item[this.searchColumn] =
                                            item[this.searchColumn] + "";
                                    }
                                    return item[this.searchColumn].includes(
                                        search
                                    );
                                } else {
                                    return false;
                                }
                            }
                        } else {
                            return true;
                        }
                    })
                    .filter((row, index) => {
                        count++;
                        return this.filterDadosPorPagina(
                            index,
                            count,
                            row.total
                        );
                    });
            }
        },
    },
};
</script>

<style scoped>
.input-group-append .input-group-text {
    background-color: #ffffff !important;
    border-color: none !important;
    color: #ababab !important;
}
.btn-sort {
    cursor: pointer;
    padding-top: 13px;
}
.btn-table {
    font-size: 16px;
}
.th-text {
    float: left;
    width: 90%;
    padding: 10px;
    height: calc(1.5em + 0.75rem + 2px);
    padding-right: 15px;
}
/* select,
input {
    float: left;
    width: 90%;
    padding: 10px;
    padding-bottom: 0;
    height: calc(1.5em + 0.75rem + 2px);
    border: 0;
    border-bottom: 1px solid #bebfc1;
}
select:focus,
input:focus {
    border: 0;
    border-bottom: 1px solid #4099ff;
} */
.btn-sort:hover {
    font-size: 16px;
}
</style>
